import { render, staticRenderFns } from "./NotificationsGroupCardContentItem.vue?vue&type=template&id=05318e7a&scoped=true"
import script from "./NotificationsGroupCardContentItem.vue?vue&type=script&lang=js"
export * from "./NotificationsGroupCardContentItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationsGroupCardContentItem.vue?vue&type=style&index=0&id=05318e7a&prod&scoped=true&lang=scss"
import style1 from "./NotificationsGroupCardContentItem.vue?vue&type=style&index=1&id=05318e7a&prod&lang=scss"
import style2 from "./NotificationsGroupCardContentItem.vue?vue&type=style&index=2&id=05318e7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05318e7a",
  null
  
)

export default component.exports